<template>
  <div class="ColumnInventer" :style="customCss">
    <Pic class="logo" :src="inverter.logo" />
    <!-- <Pic class="logo" src="../../../../../assets/quipment/inverters/znShine-logo.png" /> -->
    <div class="inverterBlock">
      <Pic class="inverter" :src="inverter.inverterPic" />
      <div class="intro">
        <div class="text">
          {{ inverter.intro }}
        </div>
      </div>
    </div>
    <div class="prosBlock">
      <div v-for="(pro, index) in inverter.pros" :key="index" class="item">
        <Pic
          :src="pro.icon" />
        <div class="text">
          <div class="label">
            {{ pro.label }}
          </div>
          <div class="value">
            {{ pro.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    inverter: Object,
  },
  computed: {
    customCss() {
      return {
        '--themeColor': `${this.inverter.themeColor || 'red'}`,
      }
    },
  },
}
</script>

<style lang="scss">
.ColumnInventer {
  font-size: 1rem;
  line-height: 1.5;
  margin: 2rem 0;
  padding: 0 1rem;
  text-align: center;
  @include sm {
    padding: 0 2rem;
  }
  @include md {
    padding: 0 2rem;
  }
  @include lg {
    padding: 0 4rem;
  }
  @include xl {
    padding: 0 6rem;
  }

  .logo {
    img {
      margin: 3rem 0 6rem;
      width: 60%;
    }
  }

  .inverterBlock {
    background: var(--themeColor);
    border-radius: 25px;
    padding: 2rem;
    position: relative;
    z-index: 2;

    .inverter {
      img {
        height: 15rem;
        margin-top: -6rem;
        text-align: center;
      }
    }

    .intro {
      margin-top: 1rem;
      text-align: left;

      .text {
        font-size: 1.5rem;
        min-height: 5rem;
        width: 90%;
      }
    }
  }

  .prosBlock {
    background: $black;
    border-radius: 25px;
    margin-top: -2rem;
    padding: 4rem 2rem 2rem;
    position: relative;
    text-align: left;
    z-index: 1;

    .item {
      display: flex;
      padding: 1rem 0;

      img {
        // display: inline-block;
        max-height: 2.5rem;
        padding: 0 1rem;
        width: 4rem;
      }

      .text {
        display: inline-block;

        .label {
          font-weight: $bold;
          line-height: 1;
        }

        .value {
          font-size: 1rem;
        }
      }
    }
  }
}
</style>
<i18n>
{
  "lt": {
    "title": "Saulės moduliai"
  }
}
</i18n>
